module.exports = __webpack_public_path__ + "img/device-default.9121a4a7.png";